module.exports = __webpack_public_path__ + "static/media/deal1.212e98f0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/deal1.png
// module id = 20
// module chunks = 0